export const EVENT_PLANK_DEFAULT = 'EVENT_PLANK_DEFAULT';
export const EVENT_PLANK_EXTENDS = 'EVENT_PLANK_EXTENDS';

export const DEFAULT_PERIOD = { start: null, end: null };
